import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const NotFound = () => (
  <>
    <SEO
      title="Page not found · Shiva Murti Sacred Healing Arts"
      description="This page could not be found."
      noindex
    />
    <section className="bg-ivory" data-testid="not-found">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-32 md:py-44 text-center">
        <p className="eyebrow">404 · Not found</p>
        <h1 className="mt-8 font-serif font-light text-temple text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
          This path does not<br />
          <span className="italic text-stone">lead anywhere.</span>
        </h1>
        <p className="mt-8 font-sans font-light text-temple text-base md:text-lg leading-[1.8] max-w-prose mx-auto">
          The page may have moved or never existed. Return to the beginning.
        </p>
        <div className="mt-12">
          <Link to="/" className="btn-ghost" data-testid="not-found-home-link">
            Return home
            <span aria-hidden>→</span>
          </Link>
        </div>
      </div>
    </section>
  </>
);

export default NotFound;
